export default __webpack_public_path__ + "static/media/rest.579d0f75.svg";